import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";

function Veiwpdf() {
  const { state } = useLocation();
  const fileName = state?.fileName || 'default.pdf'; // Fallback if no fileName is provided
  console.log(fileName);

  const navigate = useNavigate();
  // Map file names to actual PDF URLs or paths
  const fileUrlMap = {
    '123456 eDocumentation.pdf': 'https://app.lightningpresort.com/files/Temp%20Company/eDocumentation.pdf',
    '123456 Tray Tags.pdf': 'https://app.lightningpresort.com/files/Temp%20Company/eTags.pdf',
    '1234 Lost Print File.csv': 'https://pdfobject.com/pdf/sample3.pdf',
    '123456 MaolDAT.zap': 'https://pdfobject.com/pdf/sample4.pdf',
    'Receipt of Payment.pdf': 'https://pdfobject.com/pdf/sample5.pdf',
    'Origonal Invoice.pdf': 'https://pdfobject.com/pdf/sample6.pdf',
  };

  let pdfUrl = fileName || 'https://pdfobject.com/pdf/sample.pdf';
  // Append parameters to disable toolbar, navigation, status bar, and attempt to disable forms
  pdfUrl += '#toolbar=0&navpanes=0&statusbar=0&view=fitH&disableForms=true';

  return (
    <div style={{ padding: '16px', maxWidth: '896px', margin: '0 auto' }}>
      <h1 className="text-3lg font-bold text-gray-800 mb-2 hand" onClick={() => navigate(-1)}>
        <IoMdArrowRoundBack />
      </h1>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', textAlign: 'center' }}>
      
      </h1>
      <div style={{ 
        background: 'white', 
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)', 
        borderRadius: '8px', 
        overflow: 'auto', // Enable scrolling
        height: '80vh', 
        position: 'relative' 
      }}>
        <iframe
          src={pdfUrl}
          style={{ 
            width: '100%', 
            height: '100%', 
            border: 'none', 
            position: 'relative', 
            zIndex: 1, 
            userSelect: 'none', // Prevent text selection
            WebkitUserSelect: 'none', // For Safari
            MsUserSelect: 'none' // For Edge
          }}
          title={`PDF Viewer: ${fileName}`}
          onContextMenu={(e) => e.preventDefault()} // Disable right-click
          onMouseDown={(e) => e.preventDefault()} // Prevent mouse interactions
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 25%)',
            height: '100%',
            background: 'transparent',
            zIndex: 2000,
            pointerEvents: 'auto', // Block interactions except scrolling
            userSelect: 'none', // Prevent text selection
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            opacity: 0.3
          }}
        />
      </div>
    </div>
  );
}

export default Veiwpdf;